// OButton
export const ButtonSizes = Object.freeze({
  medium: 'md',
  small: 'sm'
} as const)

export type ButtonSize = (typeof ButtonSizes)[keyof typeof ButtonSizes]

export const ButtonTypes = Object.freeze({
  solid: 'solid',
  border: 'border',
  link: 'link'
} as const)

export type ButtonType = (typeof ButtonTypes)[keyof typeof ButtonTypes]

export const ButtonVariants = Object.freeze({
  primary: 'primary',
  secondary: 'secondary',
  success: 'success',
  info: 'info',
  danger: 'danger',
  dark: 'dark',
  gray: 'gray',
  ghost: 'ghost',
  white: 'white',
  gold: 'gold',
  green: 'green',
  darkGreen: 'dark-green',
  faded: 'faded',
  fadedBlack: 'faded-black',
  error: 'error'
} as const)

export type ButtonVariant = (typeof ButtonVariants)[keyof typeof ButtonVariants]

// OToaster
export const ToasterVariants = Object.freeze({
  success: 'success',
  info: 'info',
  warning: 'warning',
  danger: 'danger'
} as const)

export type ToasterVariant = (typeof ToasterVariants)[keyof typeof ToasterVariants]

// OMessage
export const MessageVariants = Object.freeze({
  danger: 'danger'
} as const)

export type MessageVariant = (typeof MessageVariants)[keyof typeof MessageVariants]

// OStatusModal
export const StatusModalVariants = Object.freeze({
  danger: 'danger',
  success: 'success'
} as const)

export type StatusModalVariant = (typeof StatusModalVariants)[keyof typeof StatusModalVariants]

// OIcon
export const IconBackgrounds = Object.freeze({
  default: 'default',
  danger: 'danger',
  success: 'success',
  warning: 'warning',
  info: 'info',
  primary: 'primary'
} as const)

export type IconBackground = (typeof IconBackgrounds)[keyof typeof IconBackgrounds]

export const IconShapes = Object.freeze({
  circle: 'circle',
  square: 'square'
} as const)

export type IconShape = (typeof IconShapes)[keyof typeof IconShapes]

export const IconSizes = Object.freeze({
  sm: 'sm',
  md: 'md',
  mdplus: 'mdplus',
  lg: 'lg'
} as const)

export type IconSize = (typeof IconSizes)[keyof typeof IconSizes]

// OLabel
export const LabelVariants = Object.freeze({
  default: 'default',
  info: 'info'
} as const)

export type LabelVariant = (typeof LabelVariants)[keyof typeof LabelVariants]

export const LabelSizes = Object.freeze({
  sm: 'sm',
  md: 'md'
} as const)

export type LabelSize = (typeof LabelSizes)[keyof typeof LabelSizes]

// OTimeline
export const TimelineOrientations = Object.freeze({
  horizontal: 'horizontal',
  vertical: 'vertical'
} as const)

export type TimelineOrientation = (typeof TimelineOrientations)[keyof typeof TimelineOrientations]

export const TimelineStates = Object.freeze({
  completed: 'completed',
  upcoming: 'upcoming'
} as const)

export type TimelineState = (typeof TimelineStates)[keyof typeof TimelineStates]

// OSkeleton
export const SkeletonVariants = Object.freeze({
  text: 'text',
  rectangular: 'rectangular',
  rounded: 'rounded',
  circular: 'circular'
} as const)

export type SkeletonVariant = (typeof SkeletonVariants)[keyof typeof SkeletonVariants]

export const SkeletonAnimations = Object.freeze({
  pulse: 'pulse',
  none: 'none'
} as const)

export type SkeletonAnimation = (typeof SkeletonAnimations)[keyof typeof SkeletonAnimations]
